<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true,
    }
  },
  updated() {
    window.scroll(0, 0);
  },
  mounted(){
    var _this = this;

    this.getChannel();

    _this.$store.commit('updateIsPC',window.innerWidth>768)
    window.onresize = function(){
      _this.$store.commit('updateIsPC',window.innerWidth>768)
    };

    if(!_this.storage.get('saleId')){
       _this.getSaleId();
    }

   // if(!_this.storage.get('city')){
      _this.getCityItem();
   // }

    //觅联新样式主题（红色风格）
    _this.setDomainIndex();
  },
  watch: {
    //监听路由是否变化
    '$route' (to, from) {
      // console.log("路由变化"+to.path);
      // 1，路由为首页，楼盘详情，楼盘动态，户型详情，全部楼盘
      // 2，使用页面内的微信分享
      if(to.path!='/' && to.path!='/estateDetail' && to.path!='/newsDetail' && to.path!='/houseType' && to.path!='/estate'){
        this.getSignatureShare();
      }
    },
  },
  methods:{
    getChannel() {
      if(this.$route.query.channel){
        let subIndex = 0;
        let searchStr = location.search;
        if(searchStr.indexOf('＆')!==-1){
          subIndex = searchStr.indexOf('＆');
        }else if(searchStr.indexOf('&')!==-1){
          subIndex = searchStr.indexOf('&');
        }
        let channel = searchStr.substring(subIndex+1, searchStr.length);
        sessionStorage.setItem('channel',channel);
      }
    },
    setDomainIndex(){
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link'),title = '',themeLink = document.querySelector('link[name="theme"]');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      if(window.location.href.indexOf('metianxia')!=-1 || window.location.href.indexOf('mtxfang')!=-1){
        this.$store.commit('updateDomainIndex',1);
        themeLink.setAttribute('href', '/static/theme/mtx/style.css');
        link.href = '/static/mtx.ico';
        title = '觅天下';
      }else if(window.location.href.indexOf('qqbdc')!=-1 || window.location.href.indexOf('mtianxia')!=-1 || window.location.href.indexOf('mtx')!=-1){
        this.$store.commit('updateDomainIndex',2);
        themeLink.setAttribute('href', '/static/theme/qqbdc/style.css');
        link.href = '/static/ml.ico';
        title = '觅联';
      // }else if(window.location.href.indexOf('zmfang')!=-1){
      //   this.$store.commit('updateDomainIndex',3);
      //   themeLink.setAttribute('href', '/static/theme/zmf/style.css');
      //   link.href = '/static/zmf.ico';
      //   title = '直迈房';
      // }else if(window.location.href.indexOf('mdrfang')!=-1){
      //   this.$store.commit('updateDomainIndex',4);
      //   themeLink.setAttribute('href', '/static/theme/mdr/style.css');
      //   link.href = '/static/mdr.ico';
      //   title = '觅达人';
      }else if(window.location.href.indexOf('salehg') != -1){//这个是使用觅联的外观，主体为溪房
        this.$store.commit('updateDomainIndex',2);//根据第二个参数显示不同平台的logo，1-觅天下，2-觅联，3-直迈房，4-觅达人，
        themeLink.setAttribute('href', '/static/theme/qqbdc/style.css');
        link.href = '/static/favion.ico';
        title = '溪房';
      }else if(window.location.href.indexOf('hbaichi') != -1){
        this.$store.commit('updateDomainIndex',1);
        themeLink.setAttribute('href', '/static/theme/mtx/style.css');
        link.href = '/static/favion.ico';
        title = '优道';
      }
      document.getElementsByTagName('head')[0].appendChild(link);
      document.getElementsByTagName('title')[0].innerText = title;
      // 微信获取密钥分享
      this.getSignatureShare();
    },
    reload (){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    },
    getSaleId:function(){
      this.$http.get(window.location.origin+'/api/estateSearch/getQueryParams?type=4').then((response)=>{
        var status=response.data.result.list, str=[];
        status.forEach(function(item){
          if(item.name=='期房在售'||item.name=='现房销售'){
            str.push(item.id)
          }
        })
        this.storage.set('saleId',str);
      }).catch((response)=>{
        console.log(response)
      })
    },
    getCityItem(){
      this.$http.get(window.location.origin+'/api/index/getCityList').then((response)=>{
        this.storage.set('cityItems',response.data.result);
        var localStorageCityCode = localStorage.getItem('cityCode');
        if(localStorageCityCode!='/'){
          for (var i = 0; i < response.data.result.length; i++) {
            var code = response.data.result[i].cityCode;
             if(code == localStorageCityCode){
                  this.storage.set('city',response.data.result[i]);
                  break;
              }
          }
            this.reload();
        }else{
          this.$router.push({name:'city',params:{local:true}});
        }

      }).catch((response)=>{
        console.log(response)
      })
    },
    // 微信获取密钥分享
    getSignatureShare(){
      var imgUrl = '';
      var shareObj = {
        link: window.location.href,
        title: document.title,
        desc: window.location.href,
        imgUrl: imgUrl,
        logoIndex: this.$store.state.domainIndex
      };
      this.$http.get('/api/wechat/getSignatureInfo?url='+shareObj.link).then((response)=>{
        if(response && response.data.result){
          this.share.weixinShare(shareObj, response);
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
  },
}
</script>

<style>
@import 'assets/css/public.css';
</style>



// WEBPACK FOOTER //
// src/App.vue